import About from "../components/Sections/About";
import Contact from "../components/Sections/Contact";

export default function ContactUs() {
//   return < AboutBanner/>
  return (
    <>
        <Contact />

    </>
  );
}
